// extracted by mini-css-extract-plugin
module.exports = {"dualtext__section":"dualtext_dualtext__section__T9WMo","container":"dualtext_container__rMIcp"};